import React from "react";
import "./DailyTransaction.css";
import { useEffect, useState, useRef } from "react";
import { Paper } from "@material-ui/core";
import {
  Table,
  Modal,
  Spinner,
  Form,
  ModalFooter,
  Badge,
} from "react-bootstrap";
import "./DailyTransaction.css";
// import data from "./mokeData";
import { baseUrl } from "../../../services/config";
import mokeData from "./mokeData.json";
import ReactToPrint from "react-to-print";
import { useAlert } from "react-alert";
import { upperCase } from "lodash";

const DailyTransaction = () => {
  const [loading, setLoading] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [yearId, setYearId] = useState("");
  const [sessionData, setSessionData] = useState([]);
  const [date, setDate] = useState("");
  const [selected, setSelected] = useState("annual");

  // const [nonCurrentData, setNonCurrentData] = useState({});
  // const [nonCurrentDetails, setNonCurrentDetails] = useState([]);
  //  const [currentData, setCurrentData] = useState({});
  // const [currentDetails, setCurrentDetails] = useState([]);
  // const [cashBankData, setCashBankData] = useState({});
  // const [cashBankDetails, setCashBankDetails] = useState([]);
  // const [liabilitiesData, setLiabilitiesData] = useState({});
  // const [liabilitiesDetails, setLiabilitiesDetails] = useState([]);
  // const [totalFeesData, setTotalFeesData] = useState({});
  // const [totalFeesDetails, setTotalFeesDetails] = useState([]);
  // const [receiptsData, setReceiptsData] = useState({});
  // const [receiptsDetails, setReceiptsDetails] = useState([]);
  // const [schoolExpenseData, setSchoolExpenseData] = useState({});
  // const [schoolExpenseDetails, setSchoolExpenseDetails] = useState([]);
  // const [societyExpenseData, setSocietyExpenseData] = useState({});
  // const [societyExpenseDetails, setSocietyExpenseDetails] = useState([]);
  const [reportData, setReportData] = useState([]);
  //for print
  const [printloading, setprintloading] = React.useState(false);
  const [text, setText] = React.useState("old boring text");
  const componentRef = useRef(null);
  const onBeforeGetContentResolve = React.useRef(null);

  const alert = useAlert();
  let authtoken = localStorage.getItem("userToken");

  const [unitName, setUnitName] = useState("");
  const [icon, setIcon] = useState([]);

  useEffect(() => {
    getSettingData();
    sessions();
  }, []);

  const getSettingData = async () => {
    await fetch(`${baseUrl}/get-settings`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setUnitName(upperCase(data.payload.settings.unit_name));
        setIcon(data.payload.settings.logo_file);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const sessions = () => {
    fetch(`${baseUrl}/session`, {
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setSessionData(data.payload);
        data.payload.forEach((session, index) => {
          if (session.active_financial_year == "1") {
            setYearId(session.id);
          }
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleDateOneChange = (text) => {
    setDate(text);
  };

  const onshowClick = () => {
    if (date == "") {
      alert.error("Please Select the date");
      return;
    }
    const data = {
      year_id: yearId,
      date: date,
      annually: selected == "annual" ? 1 : 0,
      monthly: selected == "monthly" ? 1 : 0,
      daily: selected == "daily" ? 1 : 0,
    };
    setLoading(true);

    fetch(`${baseUrl}/transaction_reports`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${authtoken}`,
      },
      body: JSON.stringify(data),
    }).then((resp) => {
      resp
        .json()
        .then((data) => {
          if (data.metadata) {
            if (data.metadata.success) {
              if (data.payload) {
                setReportData(data.payload);
                setShowTable(true);
              }
            }
          }
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          alert.error("Something wents wronge");
          setLoading(false);
        });
    });
  };

  //for print
  const handleBeforePrint = React.useCallback(() => {}, []);

  const handleOnBeforeGetContent = React.useCallback(() => {
    setprintloading(true);
    setText("Loading new text...");

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setprintloading(false);
        setText("New, Updated Text!");
        resolve();
      }, 2000);
    });
  }, [setprintloading, setText]);

  const handleAfterPrint = React.useCallback(() => {}, []);

  const onRadioButtonClick = (e) => {
    const value = e.target.value;
    setSelected(value);
  };
  return (
    <>
      <div>
        <Paper
          style={{ marginTop: "10px", marginBottom: "10px", padding: "15px" }}
        >
          <div>
            <div className="row">
              <img style={{ height: 110, width: 110 }} src={icon} alt="logo" />
              <div className="col-md-8">
                <h1>{unitName}</h1>
                <h3>Daily Transaction Report for the Date of {date}</h3>
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-4 text-center">
                <input
                  checked={selected == "annual"}
                  onChange={(e) => onRadioButtonClick(e)}
                  type="radio"
                  id="annual"
                  value="annual"
                />
                <label htmlFor="annual">Annual Wise</label>
              </div>

              <div className="col-sm-4 text-center">
                <input
                  checked={selected == "monthly"}
                  onChange={(e) => onRadioButtonClick(e)}
                  type="radio"
                  id="monthly"
                  value="monthly"
                />
                <label htmlFor="monthly">Monthly Wise</label>
              </div>

              <div className="col-sm-4 text-center">
                <input
                  checked={selected == "daily"}
                  onChange={(e) => onRadioButtonClick(e)}
                  type="radio"
                  id="daily"
                  value="daily"
                />
                <label htmlFor="daily">Daily Wise</label>
              </div>
            </div>
            <hr />
            <form>
              <div className="row">
                <div className="col-md-4">
                  <label>
                    <b>Select Session</b>
                  </label>
                  <select
                    style={{ height: 40 }}
                    className="form-select"
                    name="year_id"
                    value={yearId}
                    aria-label="Default select example"
                    onChange={(e) => setYearId(e.target.value)}
                  >
                    {sessionData &&
                      sessionData.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.year}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="row col-md-3">
                  <label>
                    <b>Select Date</b>
                  </label>
                  <input
                    onChange={(e) => handleDateOneChange(e.target.value)}
                    style={{ width: "250px", height: "39px" }}
                    type="date"
                  />
                </div>
                <div className="col-md-4 mt-9">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={onshowClick}
                  >
                    Show
                  </button>
                  {showTable ? (
                    <ReactToPrint
                      documentTitle={`Daily Transaction`}
                      pageStyle="auto"
                      onAfterPrint={handleAfterPrint}
                      onBeforeGetContent={handleOnBeforeGetContent}
                      onBeforePrint={handleBeforePrint}
                      removeAfterPrint={true}
                      trigger={() => (
                        <button
                          disabled={printloading ? true : false}
                          style={{ marginLeft: "10px" }}
                          className="btn btn-primary w-105px mx-2"
                        >
                          {printloading ? <span>Printing..</span> : "Print"}
                        </button>
                      )}
                      content={() => componentRef.current}
                    />
                  ) : null}
                </div>
              </div>
              <br />
            </form>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Spinner
                  className="text-center"
                  variant="info"
                  animation="border"
                />
              </div>
            ) : (
              <div id="tableboot"></div>
            )}
          </div>
        </Paper>

        <div>
          <Paper
            style={{
              marginTop: "10px",
              marginBottom: "10px",
              padding: "15px",
            }}
          >
            <Table responsive>
              <thead>
                <tr id="tbl">
                  <th>A/C Code</th>
                  <th>Account Name</th>
                  <th>Debit</th>
                  <th>Credit</th>
                </tr>
              </thead>

              <tbody>
                {reportData.length > 0
                  ? reportData.map((item, index) => (
                      <React.Fragment key={index}>
                        {item.debit != 0 || item.credit != 0 ? (
                          <tr>
                            <td
                              style={{ color: "black", border: "none" }}
                              className="text_align_start text-primary"
                            >
                              <h5>{item?.acode}</h5>
                            </td>
                            <td
                              style={{ color: "black", border: "none" }}
                              className="text_align_start text-primary"
                            >
                              <h5>{item?.account_name}</h5>
                            </td>
                            <td
                              style={{ color: "black", border: "none" }}
                              className="text_align_start text-primary"
                            >
                              <h5>{item?.debit}</h5>
                            </td>

                            <td
                              style={{ color: "black", border: "none" }}
                              className="text_align_start text-primary"
                            >
                              <h5>{item?.credit}</h5>
                            </td>
                          </tr>
                        ) : null}

                        {item?.account_charts.map((subAccout, subindex) => (
                          <React.Fragment key={subindex}>
                            {subAccout.total_debit != 0 ||
                            subAccout.total_credit != 0 ? (
                              <>
                                <tr id="tbl">
                                  <td
                                    style={{ color: "black", border: "none" }}
                                    className="text_align_start"
                                  >
                                    <h6>{subAccout.acode}</h6>
                                  </td>
                                  <td
                                    style={{ color: "black", border: "none" }}
                                    className="text_align_start"
                                  >
                                    <h6>{subAccout.account_name}</h6>
                                  </td>
                                </tr>

                                {subAccout?.sub_accounts.length > 0
                                  ? subAccout.sub_accounts.map(
                                      (subitem, subindex) => (
                                        <tr id="tbl" key={subindex}>
                                          <td
                                            style={{
                                              color: "black",
                                              border: "none",
                                            }}
                                            className="text_align_start"
                                          >
                                            {subitem.acode}
                                          </td>
                                          <td
                                            style={{
                                              color: "black",
                                              border: "none",
                                            }}
                                            className="text_align_start"
                                          >
                                            {subitem.account_name}
                                          </td>
                                          <td
                                            style={{
                                              color: "black",
                                              border: "none",
                                            }}
                                            className="text_align_start"
                                          >
                                            {subitem.debit}
                                          </td>
                                          <td
                                            style={{
                                              color: "black",
                                              border: "none",
                                            }}
                                            className="text_align_start"
                                          >
                                            {subitem.credit}
                                          </td>
                                        </tr>
                                      )
                                    )
                                  : null}

                                <tr id="tbl">
                                  <td
                                    style={{ color: "black", border: "none" }}
                                    className="text_align_start"
                                  ></td>

                                  <td
                                    style={{
                                      color: "black",
                                      paddingLeft: "20%",
                                      border: "none",
                                    }}
                                    className="text_align_start"
                                  >
                                    Grand Total
                                  </td>
                                  <td
                                    style={{ color: "black", border: "none" }}
                                    className="text_align_start"
                                  >
                                    {subAccout.total_debit}
                                  </td>
                                  <td
                                    style={{ color: "black", border: "none" }}
                                    className="text_align_start"
                                  >
                                    {subAccout.total_credit}
                                  </td>
                                  <td
                                    style={{ color: "black" }}
                                    className="text_align_start"
                                  ></td>
                                </tr>
                              </>
                            ) : null}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))
                  : null}
              </tbody>
            </Table>
          </Paper>
        </div>
      </div>

      {/* /////for print  */}

      <div ref={componentRef} id="printSection" className="customTablePrint">
        <div>
          <Paper
            style={{
              padding: "15px",
            }}
          >
            <div
              style={{
                display: "flex",
                padding: "10px",
              }}
            >
              <div>
                <img
                  style={{ height: 100, width: 110 }}
                  src={icon}
                  alt="logo"
                />
              </div>
              <div className="col-md-8">
                <h1>{unitName}</h1>
                <h3>Daily Transaction Report for the Date of {date}</h3>
              </div>
            </div>
            <br />
            <Table responsive style={{ padding: "1px", whiteSpace: "normal" }}>
              <thead
                style={{
                  padding: "1px",
                  whiteSpace: "normal",
                }}
              >
                <tr
                  id="tbl"
                  style={{
                    padding: "1px",
                    whiteSpace: "normal",
                  }}
                >
                  <th
                    style={{
                      fontSize: "20px",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                  >
                    A/C Code
                  </th>
                  <th
                    style={{
                      fontSize: "20px",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                  >
                    Account Name
                  </th>
                  <th
                    style={{
                      fontSize: "20px",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                  >
                    Debit
                  </th>
                  <th
                    style={{
                      fontSize: "20px",
                      padding: "1px",
                      whiteSpace: "normal",
                    }}
                  >
                    Credit
                  </th>
                </tr>
              </thead>

              <tbody
                style={{
                  padding: "1px",
                  whiteSpace: "normal",
                }}
              >
                {reportData.length > 0
                  ? reportData.map((item, index) => (
                      <React.Fragment key={index}>
                        {item.debit != 0 || item.credit != 0 ? (
                          <tr
                            style={{
                              padding: "1px",
                              whiteSpace: "normal",
                            }}
                          >
                            <td
                              style={{
                                padding: "1px",
                                whiteSpace: "normal",
                                color: "black",
                                border: "none",
                              }}
                              className="text_align_start text-primary"
                            >
                              <h5 style={{ fontSize: "20px" }}>
                                {item?.acode}
                              </h5>
                            </td>
                            <td
                              style={{
                                padding: "1px",
                                whiteSpace: "normal",
                                color: "black",
                                border: "none",
                              }}
                              className="text_align_start text-primary"
                            >
                              <h5 style={{ fontSize: "20px" }}>
                                {item?.account_name}
                              </h5>
                            </td>
                            <td
                              style={{
                                padding: "1px",
                                whiteSpace: "normal",
                                color: "black",
                                border: "none",
                              }}
                              className="text_align_start text-primary"
                            >
                              <h5 style={{ fontSize: "20px" }}>
                                {item?.debit}
                              </h5>
                            </td>

                            <td
                              style={{
                                padding: "1px",
                                whiteSpace: "normal",
                                color: "black",
                                border: "none",
                              }}
                              className="text_align_start text-primary"
                            >
                              <h5 style={{ fontSize: "20px" }}>
                                {item?.credit}
                              </h5>
                            </td>
                          </tr>
                        ) : null}

                        {item?.account_charts.map((subAccout, subindex) => (
                          <React.Fragment key={subindex}>
                            {subAccout.total_debit != 0 ||
                            subAccout.total_credit != 0 ? (
                              <>
                                <tr
                                  id="tbl"
                                  style={{
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "1px",
                                      whiteSpace: "normal",
                                      color: "black",
                                      border: "none",
                                    }}
                                    className="text_align_start"
                                  >
                                    <h6 style={{ fontSize: "20px" }}>
                                      {subAccout.acode}
                                    </h6>
                                  </td>
                                  <td
                                    style={{
                                      padding: "1px",
                                      whiteSpace: "normal",
                                      color: "black",
                                      border: "none",
                                    }}
                                    className="text_align_start"
                                  >
                                    <h6 style={{ fontSize: "20px" }}>
                                      {subAccout.account_name}
                                    </h6>
                                  </td>
                                </tr>

                                {subAccout?.sub_accounts.length > 0
                                  ? subAccout.sub_accounts.map(
                                      (subitem, subindex) => (
                                        <tr
                                          key={subindex}
                                          id="tbl"
                                          style={{
                                            padding: "1px",
                                            whiteSpace: "normal",
                                            color: "black",
                                            border: "none",
                                          }}
                                        >
                                          <td
                                            style={{
                                              fontSize: "20px",
                                              padding: "1px",
                                              whiteSpace: "normal",
                                              color: "black",
                                              border: "none",
                                            }}
                                            className="text_align_start"
                                          >
                                            {subitem.acode}
                                          </td>
                                          <td
                                            style={{
                                              fontSize: "20px",
                                              padding: "1px",
                                              whiteSpace: "normal",
                                              color: "black",
                                              border: "none",
                                            }}
                                            className="text_align_start"
                                          >
                                            {subitem.account_name}
                                          </td>
                                          <td
                                            style={{
                                              fontSize: "20px",
                                              padding: "1px",
                                              whiteSpace: "normal",
                                              color: "black",
                                              border: "none",
                                            }}
                                            className="text_align_start"
                                          >
                                            {subitem.debit}
                                          </td>
                                          <td
                                            style={{
                                              fontSize: "20px",
                                              padding: "1px",
                                              whiteSpace: "normal",
                                              color: "black",
                                              border: "none",
                                            }}
                                            className="text_align_start"
                                          >
                                            {subitem.credit}
                                          </td>
                                        </tr>
                                      )
                                    )
                                  : null}

                                <tr
                                  id="tbl"
                                  style={{
                                    padding: "1px",
                                    whiteSpace: "normal",
                                  }}
                                >
                                  <td
                                    style={{
                                      padding: "1px",
                                      whiteSpace: "normal",
                                      color: "black",
                                      border: "none",
                                    }}
                                    className="text_align_start"
                                  ></td>

                                  <td
                                    style={{
                                      padding: "1px",
                                      whiteSpace: "normal",
                                      color: "black",
                                      paddingLeft: "20%",
                                      border: "none",
                                    }}
                                    className="text_align_start"
                                  >
                                    <b style={{ fontSize: "20px" }}>
                                      Grand Total
                                    </b>
                                  </td>
                                  <td
                                    style={{
                                      padding: "1px",
                                      whiteSpace: "normal",
                                      color: "black",
                                      border: "none",
                                      borderTop: "1px solid black",
                                      borderBottom: "1px solid black",
                                    }}
                                    className="text_align_start"
                                  >
                                    <b style={{ fontSize: "20px" }}>
                                      {subAccout.total_debit}
                                    </b>
                                  </td>
                                  <td
                                    style={{
                                      padding: "1px",
                                      whiteSpace: "normal",
                                      color: "black",
                                      border: "none",
                                      borderTop: "1px solid black",
                                      borderBottom: "1px solid black",
                                    }}
                                    className="text_align_start"
                                  >
                                    <b style={{ fontSize: "20px" }}>
                                      {subAccout.total_credit}
                                    </b>
                                  </td>
                                </tr>
                              </>
                            ) : null}
                          </React.Fragment>
                        ))}
                      </React.Fragment>
                    ))
                  : null}
              </tbody>
            </Table>
          </Paper>
        </div>
      </div>
    </>
  );
};

export default DailyTransaction;
